'use strict';

/* global $ */

import { Ajax } from '../utils/ajax';
import { AjaxMore } from '../modules/ajax-more';

class Favorite {
    constructor(options) {
        this.opt = $.extend(true, {}, {
            status: options.selector+'__status',
            block: options.selector+'__block',
            more: options.selector+'__button',
            button: options.selector+'__link',
        }, options);

        let self = this;
        //$(this.opt.selector).each(function() {
            self.init(options.selector);
        //});
    }
    init(el) {
        console.log('[ Favorite/Init ]');
        //let $el = $(el);
        let $body = $(document.body);
        let opt = this.opt;
        this.setFavorites(opt.button);
        let block = new AjaxMore({selector: this.opt.selector});
        $body.on('click', opt.button, function(e) {
            console.log('[ Favorite/Toggle ]');
            e.preventDefault();
            let store = JSON.parse(localStorage.getItem('radiobox')) || {};
            let stations = store.favorite || [];
            let id = $(this).data('id');
            let index = stations.indexOf(id);
            (index !== -1) ? stations.splice(index, 1) : stations.push(id);
            (index !== -1) ? $(this).find(opt.status).text('В избранное') : $(this).find(opt.status).text('В избранном');
            store.favorite = stations;
            localStorage.setItem('radiobox', JSON.stringify(store));
            if ($(this).hasClass('m--animate')) {
                $(this).addClass('m--on');
                $(this).on('animationend', function(e) {
                    $(this).removeClass('m--on');
                });
            } else if ($(this).find('.m--animate').length) {
                $(this).find('.m--animate').addClass('m--on');
                $(this).find('.m--animate').on('animationend', function(e) {
                    $(this).removeClass('m--on');
                });
            }
            $(this).toggleClass('is-active');
            /*
            Ajax.get('set_rating', { id: id, direction: direction }).then((data) => {
                console.log('[ Like/get/then ]');
                console.log(data);
                if (data.ok) {
                    $(opt.counter).text(data.like_count);
                }
            });
            */
        });
    }
    setFavorites(el) {
        let store = JSON.parse(localStorage.getItem('radiobox')) || {};
        let stations = store.favorite?.filter((item) => item) || [];
        let self = this;
        $(self.opt.more).attr('data-ids', JSON.stringify(stations));
        $(self.opt.more).attr('data-total', stations.length);
        $(el).each(function() {
            let id = $(this).data('id');
            let index = stations.indexOf(id);
            (index !== -1) ? $(this).addClass('is-active') : $(this).removeClass('is-active');
            (index !== -1) ? $(this).find(self.opt.status).text('В избранном') : $(this).find(self.opt.status).text('В избранное');
        });
    }
}

export {
    Favorite
};
